import React, { SyntheticEvent, useEffect, useState } from 'react';
import axios from 'axios';
import './UsersEdit.scss';
import { Box, Card, Tab, Tabs, Typography } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UsersEditPasswordForm from './UsersEditPasswordForm';
import UsersEditForm from './UsersEditForm';
import { AuthHeader } from '../../../utils/helpers/auth-headers';

interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
}

interface TabPanelProps {
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const a11yProps = (index: number) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

function UsersEdit() {
  const { t } = useTranslation();

  const [value, setValue] = useState(0);

  const { userId } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState<User>({
    _id: '',
    name: '',
    email: '',
    role: '',
  });

  useEffect(() => {
    axios.get(`${window._env_.REACT_APP_API_URI}/user/${userId}`, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} })
      .then((response) => {
        setUser(response.data.data);
      })
      .catch((error) => {
        if (error.response) {
          const err = error.response;
          console.error(err);
          navigate('/configuration/users');
        }
        console.error(error);
      });
  }, [userId, navigate]);

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="category-container">
      <Card>
        <div className="card-title">{ t('UsersEdit.title') }</div>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChangeTabs} aria-label="basic tabs example">
              <Tab label={t('UsersEdit.tab1')} {...a11yProps(0)} />
              <Tab label={t('UsersEdit.tab2')} {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <UsersEditForm selectedUser={user} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UsersEditPasswordForm selectedUser={user} />
          </TabPanel>
        </Box>
      </Card>
    </div>
  );
}

export default UsersEdit;
